import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {getLocalData} from '../../services/StorageServices';

export const useRoles = (propRoles) => {
    const reduxRoles = useSelector(state => state.rolesReducer.roles);

    return useMemo(() => {
        if (propRoles?.length > 0) return propRoles;
        if (reduxRoles?.length > 0) return reduxRoles;
        return getLocalData('roles') || [];
    }, [propRoles, reduxRoles]);
};